<script setup lang="ts">
import { useCuratedEvents } from '~/composables/apostatudo/use-curated-events';

withDefaults(
  defineProps<{
    hideHeader?: boolean;
  }>(),
  { hideHeader: false },
);

const {
  fetchAll,
  setSelectedDate,
  events,
  selectedDate,
  availableDates,
  hasEvents,
  loading,
  error,
} = useCuratedEvents();

const eventListRef = ref<{
  scrollToDate: (date: string) => void;
} | null>(null);

onMounted(async () => {
  await fetchAll();
});

const shouldHide = computed(
  () => !loading.value && (!!error.value || availableDates.value.length === 0),
);

function onSelectDate(date: string) {
  eventListRef.value?.scrollToDate(date);
}

function onDateChange(date: string) {
  setSelectedDate(date);
}
</script>

<template>
  <section
    v-if="!shouldHide"
    :class="$style.section"
  >
    <PerfilOficialSwiperHeader
      v-if="!hideHeader"
      icon-path="home/jogos-em-destaque"
      see-more-url="/sports"
      title="Jogos em destaque"
    />

    <div :class="$style.swiperContainer">
      <SportsCuratedEventsDateNavigator
        :available-dates="availableDates"
        :selected-date="selectedDate"
        @select="onSelectDate"
      />

      <div
        v-if="loading"
        :class="$style.skeletonCards"
      >
        <BaseCommonSkeleton
          v-for="i in 4"
          :key="i"
          :class="$style.skeletonCard"
        />
      </div>

      <SportsCuratedEventsEventList
        v-else-if="hasEvents"
        ref="eventListRef"
        :events="events"
        @date-change="onDateChange"
      />

      <p
        v-else
        :class="$style.empty"
      >
        Nenhum jogo curado disponível.
      </p>
    </div>
  </section>
</template>

<style module lang="postcss">
.section {
  @apply my-1 lg:my-3;

  .swiperContainer {
    @apply h-[244px] flex flex-col px-0 py-2.5;

    @media (min-width: 1024px) {
      @apply px-5;
      border-radius: 10px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 93.13%,
        rgba(0, 0, 0, 0.1) 100%
      );
    }
  }

  .skeletonCards {
    @apply flex gap-3 overflow-hidden h-48;

    .skeletonCard {
      @apply h-full min-w-[360px] flex-1;
    }
  }

  .empty {
    @apply flex-1 flex items-center justify-center text-sm text-white/60 px-2 text-center;
  }
}
</style>
